import { getField } from 'vuex-map-fields';

export default {
  addConversationActivity: state => state.addConversationActivity,
  removeConversationActivity: state => state.removeConversationActivity,
  allowEnter: state => state.allowEnter,
  conversationList: state => state.conversationList,
  allConversationsList: state => state.allConversationsList,
  conversationsLoad: state => state.conversationsLoad,
  activeConversation: state => state.activeConversation,
  enterPressed: state => state.enterPressed,
  unreadConversationsCount: state => state.unreadConversationsCount,
  reassignedConversation: state => state.reassignedConversation,
  conversationSeen: state => state.conversationSeen,

  messageList: state => state.messageList,
  messagesLoaded: state => state.messagesLoaded,
  messagesLoading: state => state.messagesLoading,
  sentMessageStatus: state => state.sentMessageStatus,
  messageSent: state => state.messageSent,

  quickReplyList: state => state.quickReplyList,
  quickRepliesLoaded: state => state.quickRepliesLoaded,
  quickReplyCreated: state => state.quickReplyCreated,
  quickReplyUpdated: state => state.quickReplyUpdated,
  quickReplyDeleted: state => state.quickReplyDeleted,

  statistics: state => state.statistics,

  botStatusUpdated: state => state.botStatusUpdated,
  folderChanged: state => state.folderChanged,

  apiError: state => state.apiError,
  fileUploadError: state => state.fileUploadError,
  getField,
  chatFastReload: state => state.chatFastReload,
  conversationFastReload: state => state.conversationFastReload,
  chatSearchAllNumbersSelected: state => state.chatSearchAllNumbersSelected,
  messageCountChange: state => state.messageCountChange,
  startNewConversationSelectId: state => state.startNewConversationSelectId,
  startConversationNumber: state => state.startConversationNumber,
  tempConversations: state => state.tempConversations,
  folder: state => state.folder,
  showEmptyDone: state => state.showEmptyDone,
  showEmptyOpen: state => state.showEmptyOpen,
  showEmptyFresh: state => state.showEmptyFresh,
  forceConversationLoadSpinner: state => state.forceConversationLoadSpinner,
  resetConversationListFlag: state => state.resetConversationListFlag,
  reloadFirstPage: state => state.reloadFirstPage,
  addMessage: state => state.addMessage,
  removeMessage: state => state.removeMessage,
  inputMessageText: state => state.inputMessageText,
  botStateChange: state => state.botStateChange,
  updateConversations: state => state.updateConversations,
  inputBackup: state => state.inputBackup,
  pusherEmojiReactionReceived: state => state.pusherEmojiReactionReceived,
};
